let scrollbarSize

// Measure scrollbar width for padding body during modal show/hide
const scrollbarMeasure = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px',
  overflow: 'scroll',
}

export function measureScrollbar(direction = 'vertical') {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0
  }
  if (scrollbarSize) {
    return scrollbarSize
  }
  const scrollDiv = document.createElement('div')
  Object.keys(scrollbarMeasure).forEach(scrollProp => {
    scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp]
  })
  document.body.appendChild(scrollDiv)
  let size = 0
  if (direction === 'vertical') {
    size = scrollDiv.offsetWidth - scrollDiv.clientWidth
  } else if (direction === 'horizontal') {
    size = scrollDiv.offsetHeight - scrollDiv.clientHeight
  }

  document.body.removeChild(scrollDiv)
  scrollbarSize = size
  return scrollbarSize
}

/*
 * Clamp a value between two other values
 * @param {number} number
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
export function clamp(number, min = 0, max = 1) {
  return Math.min(Math.max(number, min), max)
}

/*
 * Get the percentage scrolled over an element
 * @param {HTMLElement} element
 * @return {number} value between 0 and 1
 */
export function scrolledOverPercent(element) {
  const scrolled = window.pageYOffset
  const height = element.offsetHeight
  const top = element.offsetTop
  const percent = scrolled / (top + height)

  return clamp(percent)
}

/*
 * Resize to original aspect ratio
 * @param {Object} dimensions The original dimensions
 * @param {number} dimensions.height
 * @param {number} dimensions.width
 * @param {string} prop Property name
 * @param {number} value Current property value
 * @param {Object} new height and width
 */
export function resizeToRatio(dimensions, prop, value) {
  const otherProp = prop === 'width' ? 'height' : 'width'
  const otherPropValue = Math.round(
    (value * dimensions[otherProp]) / dimensions[prop]
  )

  return {
    [otherProp]: otherPropValue,
    [prop]: value,
  }
}

/*
 * Simulate "background-position: contain"
 * @param {Object} dimensions The original dimensions
 * @param {number} dimensions.height
 * @param {number} dimensions.width
 * @param {Object} maxDimensions The available space
 * @param {number} maxDimensions.height
 * @param {number} maxDimensions.width
 * @return {Object} new height and width
 */
export function resizeToContain(dimensions, maxDimensions) {
  return Object.keys(dimensions).reduce(
    (prevDimensions, prop) =>
      prevDimensions[prop] > maxDimensions[prop]
        ? resizeToRatio(prevDimensions, prop, maxDimensions[prop])
        : prevDimensions,
    dimensions
  )
}

/*
 * Simulate "background-position: cover"
 * @param {Object} dimensions The original dimensions
 * @param {number} dimensions.height
 * @param {number} dimensions.width
 * @param {Object} maxDimensions The available space
 * @param {number} maxDimensions.height
 * @param {number} maxDimensions.width
 * @return {Object} new height and width
 */
export function resizeToCover(dimensions, maxDimensions) {
  const dimensionsAfterContain = resizeToContain(dimensions, maxDimensions)

  return Object.keys(dimensions).reduce(
    (prevDimensions, prop) =>
      prevDimensions[prop] < maxDimensions[prop]
        ? resizeToRatio(prevDimensions, prop, maxDimensions[prop])
        : prevDimensions,
    dimensionsAfterContain
  )
}

export function toNetlifyFormData(value, formData = new FormData(), key = '') {
  // let formKey = namespace  && `${namespace}[${key}]` : key
  if (value instanceof Array) {
    value.forEach((element, index) => {
      const tempFormKey = `${key}[]`
      toNetlifyFormData(element, formData, tempFormKey)
    })
  } else if (value instanceof Date) {
    formData.append(key, value.toISOString())
  } else if (
    typeof value === 'object' &&
    value !== null &&
    !(value instanceof File)
  ) {
    Object.keys(value).forEach(k =>
      toNetlifyFormData(value[k], formData, key ? `${key}[${k}]` : k)
    )
  } else {
    formData.append(
      key,
      typeof value === 'undefined' || value === null ? '' : value
    )
  }

  return formData
}

export const startCase = string =>
  string
    .split(' ')
    .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
    .join(' ')

export { symbolByCode as currencySymbolByCode } from './currencies'

export const SortOrder = {
  ASC: 'ascend',
  DESC: 'descend',
}

export const cycleSort = (curr, allowNull) => {
  if (curr === SortOrder.ASC) return SortOrder.DESC
  if (curr === SortOrder.DESC && allowNull) return null

  return SortOrder.ASC
}

export const withoutProps = (props, propTypes) => {
  let newProps = Object.assign({}, props)
  for (let prop in propTypes) {
    delete newProps[prop]
  }
  return newProps
}

export const localeCompareFunc = prop => (a, b) =>
  a[prop].localeCompare(b[prop])

export const getControlPanelFromHost = host =>
  host.gameInfo.controlPanel && host.gameInfo.controlPanel.type
    ? host.gameInfo.controlPanel
    : host.controlPanel

export const noEmpty = (parts, ...args) =>
  parts.reduce(
    (acc, curr, i) => (acc += curr + (args[i] == null ? '' : args[i])),
    ''
  )

export const checkWebPSupport = (feature, callback) => {
  var kTestImages = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha:
      'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation:
      'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
  }
  var img = new Image()
  img.onload = function() {
    var result = img.width > 0 && img.height > 0
    callback(feature, result)
  }
  img.onerror = function() {
    callback(feature, false)
  }
  img.src = 'data:image/webp;base64,' + kTestImages[feature]
}

export const addQuery = (url, newParams) => {
  const keys = Object.keys(newParams)
  if (keys.length === 0) return url

  const qm = url.indexOf('?')
  const append = keys.map(k => `${k}=${newParams[k]}&`).join('')
  if (qm === -1) return url + `?` + append
  else return url.substring(0, qm + 1) + append + url.substring(qm + 1)
}

export const omitSingle = (object = {}, key) => {
  if (key === null || key === undefined || !(key in object)) return object
  const { [key]: deleted, ...otherKeys } = object
  return otherKeys
}

export const omitMultiple = (object = {}, keys) => {
  if (!Array.isArray(keys)) return object
  return keys.reduce((result, key) => {
    if (key in result) {
      return omitSingle(result, key)
    }
    return result
  }, object)
}

export const omit = (object = {}, keys) => {
  if (!keys) return object
  if (Array.isArray(keys)) {
    // calling omitMultiple here would result in a second array check
    return keys.reduce((result, key) => {
      if (key in result) {
        return omitSingle(result, key)
      }
      return result
    }, object)
  }
  return omitSingle(object, keys)
}

export const isEmail = email => {
  const regex = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i

  return regex.test(String(email).toLowerCase())
}



// WEBPACK FOOTER //
// /opt/build/repo/src/utils/index.js